<template>
  <div v-show="vk_visible" :class="keyboardClass"></div>
</template>

<script>
import Keyboard from 'simple-keyboard';
import 'simple-keyboard/build/css/index.css';
import { mapMutations, mapState } from 'vuex';
import snq from 'snq';

export default {
  name: 'SimpleKeyboard',
  props: {
    keyboardClass: {
      default: 'simple-keyboard',
      type: String,
    },
    input: {
      type: String,
    },
  },
  data: () => ({
    keyboard: null,
    button: null,
  }),
  computed: {
    ...mapState('helper', ['vk_input', 'vk_visible']),
  },
  mounted() {
    this.keyboard = new Keyboard({
      onChange: this.onChange,
      onKeyPress: this.onKeyPress,
      display: {
        '{bksp}': 'C',
        '{enter}': 'Confirm',
      },
      layout: {
        default: ['1 2 3', '4 5 6', '7 8 9', '0 . {bksp}', '{enter}'],
      },
      theme: 'hg-theme-default hg-layout-numeric numeric-theme',
      preventMouseDownDefault: true,
    });
  },
  methods: {
    ...mapMutations('helper', ['vk_hide']),

    onDestroy() {
      this.keyboard.destroy();
    },
    onChange(input) {
      let amount = input;

      const dotCount = (amount.match(RegExp('\\.', 'g')) || []).length;

      if (dotCount > 1 && this.button === '.') {
        const newInput = amount.slice(0, -1);
        this.keyboard.setInput(newInput);
        this.keyboard.setCaretPosition(newInput.length);
        return;
      }

      const length = snq(() => amount.split('.')[1].length);

      //only allow two decimal like 11.22
      if (length > 2) {
        this.keyboard.setInput(amount.slice(0, -1));
        this.keyboard.setCaretPosition(amount.length - 1);
        return;
      }

      this.keyboard.setCaretPosition(amount.length);
      this.keyboard.setInput(amount);
      this.$store.commit('helper/vk_update_value', amount);
    },
    onKeyPress(button) {
      this.button = button;
      if (button === '{enter}') {
        setTimeout(() => {
          this.vk_hide();
          document.activeElement.blur();
        }, 300);
      }
      this.$emit('onKeyPress', button);

      /**
       * If you want to handle the shift and caps lock buttons
       */
      if (button === '{shift}' || button === '{lock}') this.handleShift();
    },
    handleShift() {
      let currentLayout = this.keyboard.options.layoutName;
      let shiftToggle = currentLayout === 'default' ? 'shift' : 'default';

      this.keyboard.setOptions({
        layoutName: shiftToggle,
      });
    },
  },
  watch: {
    input(input) {
      if (input) this.keyboard.setInput(input);
    },
    vk_input(input) {
      if (input) this.keyboard.setInput(input.value);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
input {
  width: 100%;
  height: 100px;
  padding: 20px;
  font-size: 20px;
  border: none;
  box-sizing: border-box;
}

.simple-keyboard {
  max-width: 850px;
}
</style>
